import { EventEmitter, Injectable } from '@angular/core';

import { UniversalStorageService } from './universal-storage.service';

import { User } from 'src/interface/user';
const BEARER_TOKEN = 'BEARER_TOKEN';

@Injectable({
    providedIn: 'root',
})
export class UserTokenService {
    constructor(private storageService: UniversalStorageService) {}
    //private loggedInUserSubject = new BehaviorSubject<User | null>(null);
    loggedInUserChanged: EventEmitter<User | null> =
        new EventEmitter<User | null>();

    clear() {
        this.storageService.removeItem(BEARER_TOKEN);
        //  this.loggedInUserSubject.next(null);
    }

    setToken(token: string): void {
        this.storageService.setItem(BEARER_TOKEN, token);
    }

    getBearerToken() {
        return this.storageService.getItem(BEARER_TOKEN);
    }

    setLoggedInUser(user: User): void {
        // this.loggedInUserSubject.next(user);
        this.loggedInUserChanged.next(user);
        this.loggedInUserChanged.emit(user);
    }
}
